import React, { FC } from 'react';
import styled from '@emotion/styled';
import FilledInfoIcon from '../icons/FilledInfoIcon';
import StatusBarWrapper from './StatusBarWrapper';
import { StatusType, StatusBadge } from '../badges';

const InProgressStatusBarWrapper = styled(StatusBarWrapper)`
  background-color: #57a8e6;
`;

export interface InprogressStatusBarProps {
  status?: StatusType | string;
  hideBadge?: boolean;
  message?: string;
}

export const InProgressStatusBar: FC<InprogressStatusBarProps> = props => {
  return (
    <InProgressStatusBarWrapper data-testid="in-progress-status-bar">
      <FilledInfoIcon />
      <p>
        {props.message !== undefined
          ? props.message
          : 'This project may take a few minutes to fully process. The page will automatically refresh to show updated data.'}
      </p>
      {props.status !== undefined && !props.hideBadge && (
        <StatusBadge status={props.status}></StatusBadge>
      )}
    </InProgressStatusBarWrapper>
  );
};

export default InProgressStatusBar;
